/* BR LAYOUT — makes the mega menu fade OUT as well as in.
   A <details> element hides its content the instant `open` is removed, so a CSS
   transition can only ever be seen on the way in. Holding the element open for
   the length of the animation, with a class that drives the closing state, is
   what makes the close visible. */
(function () {
  'use strict';

  function speed() {
    var v = getComputedStyle(document.documentElement)
      .getPropertyValue('--br-menu-speed').trim();
    var n = parseFloat(v);
    if (!n) return 320;
    return /ms$/.test(v) ? n : n * 1000;   // accept 320ms or .32s
  }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bind(details) {
    if (details.dataset.brFade === '1') return;
    details.dataset.brFade = '1';
    var summary = details.querySelector('summary');
    if (!summary) return;

    summary.addEventListener('click', function (e) {
      if (!details.open || reduced) return;      // opening: CSS handles it
      e.preventDefault();
      if (details.classList.contains('br-closing')) return;
      details.classList.add('br-closing');
      window.setTimeout(function () {
        details.classList.remove('br-closing');
        details.open = false;
      }, speed());
    });

    /* The theme closes menus on outside click and on Escape by setting `open`
       directly. Mirror the fade there too, otherwise those paths still snap. */
    document.addEventListener('click', function (e) {
      if (!details.open) return;
      if (details.contains(e.target)) return;
      softClose(details);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.open) softClose(details);
    });
  }

  function softClose(details) {
    if (reduced) { details.open = false; return; }
    if (details.classList.contains('br-closing')) return;
    details.classList.add('br-closing');
    window.setTimeout(function () {
      details.classList.remove('br-closing');
      details.open = false;
    }, speed());
  }

  function scan() {
    document.querySelectorAll('details.mega-menu').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // headers get re-rendered by the theme editor and by section reloads
  new MutationObserver(scan).observe(document.documentElement,
    { childList: true, subtree: true });

  /* ---- stacked header: currency-selector placement ----
     This used to relocate the selector out of `.header__icons` and into the
     nav row, one merchant decision back. The merchant has now asked for it
     "tucked away in the far right corner" instead -- which is exactly
     `.header__icons`, its ORIGINAL location before that move existed. So the
     fix is to stop moving it, not to move it somewhere new.
     Left as a no-op (rather than deleted) so the corresponding CSS in
     br-layout.css, which only matches the .br-hdr-localization class this
     used to add, simply never activates -- nothing to clean up there. */
  function stackHeader() {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stackHeader);
  } else {
    stackHeader();
  }
  document.addEventListener('shopify:section:load', stackHeader);
})();
